import React from 'react';

function Privacy() {
  return (
    <section className="services-details section-padding">
      <div className="container">
        <div className="sec-head text-left mb-80">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div>

                <div className="text">


                  <p><strong>1. Introduction</strong></p>
                  <p>At Aashway, we respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data when you interact with our website or services.</p>

                  <p><strong>2. Information We Collect</strong></p>
                  <p>We may collect the following types of information:</p>

                  <p><strong>Personal Information</strong></p>
                  <ul>
                    <li>Name</li>
                    <li>Email address</li>
                    <li>Phone number</li>
                    <li>Business details (if provided)</li>
                  </ul>

                  <p><strong>Project Information</strong></p>
                  <ul>
                    <li>Content, images, credentials, and other materials shared for project execution</li>
                  </ul>

                  <p><strong>Technical Data</strong></p>
                  <ul>
                    <li>IP address</li>
                    <li>Browser type</li>
                    <li>Device information</li>
                    <li>Website usage data (via analytics tools)</li>
                  </ul>

                  <p><strong>3. How We Use Your Information</strong></p>
                  <p>We use your information to:</p>
                  <ul>
                    <li>Communicate with you regarding services</li>
                    <li>Deliver and manage projects</li>
                    <li>Improve our website and services</li>
                    <li>Send updates, proposals, or relevant information</li>
                  </ul>

                  <p><strong>4. Cookies & Tracking Technologies</strong></p>
                  <p>Our website may use cookies and similar technologies to:</p>
                  <ul>
                    <li>Improve user experience</li>
                    <li>Analyze website traffic</li>
                    <li>Run ads (e.g., retargeting)</li>
                  </ul>
                  <p>You can disable cookies through your browser settings.</p>

                  <p><strong>5. Data Sharing</strong></p>
                  <p>We do <strong>not sell your personal data</strong>.</p>
                  <p>We may share data only with:</p>
                  <ul>
                    <li>Trusted third-party tools (hosting, analytics, email services)</li>
                    <li>Payment providers (for transaction processing)</li>
                    <li>Legal authorities (if required by law)</li>
                  </ul>

                  <p><strong>6. Data Security</strong></p>
                  <p>We take reasonable measures to protect your data from:</p>
                  <ul>
                    <li>Unauthorized access</li>
                    <li>Data loss or misuse</li>
                  </ul>
                  <p>However, no method of transmission over the internet is 100% secure.</p>

                  <p><strong>7. Third-Party Services</strong></p>
                  <p>We may use third-party platforms such as:</p>
                  <ul>
                    <li>Hosting providers</li>
                    <li>Analytics tools (like Google Analytics)</li>
                    <li>Payment gateways</li>
                  </ul>
                  <p>We are not responsible for how these third parties handle your data.</p>

                  <p><strong>8. Your Rights</strong></p>
                  <p>You have the right to:</p>
                  <ul>
                    <li>Request access to your data</li>
                    <li>Request correction or deletion of your data</li>
                    <li>Opt out of marketing communications</li>
                  </ul>
                  <p>To do so, contact us at: <a href="mailto:contact@aashway.in">contact@aashway.in</a></p>

                  <p><strong>9. Data Retention</strong></p>
                  <p>We retain your data only as long as necessary for:</p>
                  <ul>
                    <li>Project completion</li>
                    <li>Legal or business purposes</li>
                  </ul>

                  <p><strong>10. Children’s Privacy</strong></p>
                  <p>Our services are not intended for individuals under the age of 18. We do not knowingly collect data from children.</p>

                  <p><strong>11. Updates to This Policy</strong></p>
                  <p>We may update this Privacy Policy from time to time. Changes will be posted on this page.</p>

                  <p><strong>12. Contact Information</strong></p>
                  <p>If you have any questions regarding this policy, you can contact us at:</p>
                  <p>📧 <a href="mailto:contact@aashway.in">contact@aashway.in</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Privacy;
